export type SortOrder = 'ASC' | 'DESC'

export type ColumnSort<Field extends string> = {
  field: Field
  order: SortOrder
} | null

export type OrderByParams<Field extends string> = Partial<
  Record<`${Field}OrderBy`, SortOrder>
>

export const getNextColumnSort = <Field extends string>(
  current: ColumnSort<Field>,
  field: Field
): ColumnSort<Field> => {
  if (current?.field !== field) return { field, order: 'ASC' }
  if (current.order === 'ASC') return { field, order: 'DESC' }
  return null
}

export const getColumnSortOrder = <Field extends string>(
  sort: ColumnSort<Field>,
  field: Field
): SortOrder | null => (sort?.field === field ? sort.order : null)

export const toOrderByParams = <Field extends string>(
  sort: ColumnSort<Field>
): OrderByParams<Field> => {
  if (!sort) return {}
  const params: OrderByParams<Field> = {}
  params[`${sort.field}OrderBy`] = sort.order
  return params
}
